function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

/**
 * Check if we're in a server-side rendering context
 */
var isSSR = function isSSR() {
  return typeof window === "undefined";
};

var _document$currentScri;
var scriptTag = ! /*#__PURE__*/isSSR() ? (_document$currentScri = document.currentScript) == null ? void 0 : _document$currentScri.src : null;
var suffix = "";

if (scriptTag) {
  var source = /*#__PURE__*/new URL(scriptTag).host;
  suffix = "(via " + source + ")";
} else if (isSSR()) {
  suffix = "(SSR)";
}
/**
 * user agent of sdk
 * @hidden
 */


var USER_AGENT = /*#__PURE__*/["sajari-sdk-js/2.10.8", suffix].filter(Boolean).join(" ");

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    this.events = {};
  }

  var _proto = EventEmitter.prototype;

  _proto.emit = function emit(event) {
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    if (this.events["*"]) {
      this.events["*"].forEach(function (cb) {
        return cb.apply(void 0, [event].concat(data));
      });
    }

    if (!this.events[event]) {
      return;
    }

    this.events[event].forEach(function (cb) {
      return cb.apply(void 0, data);
    });
  };

  _proto.on = function on(event, callback) {
    var _this = this;

    if (!this.events[event]) {
      this.events[event] = [];
    }

    this.events[event].push(callback);
    return function () {
      _this.events[event] = _this.events[event].filter(function (item) {
        return item !== callback;
      });
    };
  };

  return EventEmitter;
}();

/**
 * RequestError defines an error occuring from a request.
 */

var RequestError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(RequestError, _Error);

  function RequestError(statusCode, message, error) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.statusCode = statusCode;
    _this.error = error; // TODO(jingram): Remove this when compilation target is higher than ES5.

    Object.setPrototypeOf(_assertThisInitialized(_this), RequestError.prototype);
    return _this;
  }

  return RequestError;
}( /*#__PURE__*/_wrapNativeSuper(Error)); // Having a proxy helps enables SSR execution (docs)

var setItem = function setItem(key, value) {
  if (isSSR()) {
    return;
  }

  try {
    localStorage.setItem(key, value);
  } catch (_) {
    console.error("Search.io local storage \"" + key + "\" cannot be saved.", value);
  }
};
var getItem = function getItem(key) {
  if (isSSR()) {
    return "";
  }

  return localStorage.getItem(key);
};

var STORAGE_KEY = "searchio_events";
var EXPIRY_DAYS = 30;
var FUNNEL_ENTRY_TYPES = ["click", "redirect", "promotion_click"];
/**
 * SearchIOAnalytics is a utility class for tracking and sending Search.io events.
 * Event data is persisted to localStorage before being sent to track how users use
 * search results and/or move through an ecommerce purchase funnel.
 */

var SearchIOAnalytics = /*#__PURE__*/function () {
  function SearchIOAnalytics(account, collection, endpoint) {
    var _this = this;

    if (endpoint === void 0) {
      endpoint = "https://api.search.io";
    }

    this.account = account;
    this.collection = collection;
    this.endpoint = endpoint;
    var storageContent = getItem(STORAGE_KEY);

    try {
      this.events = storageContent ? JSON.parse(storageContent) : {};
    } catch (e) {
      this.events = {};
      console.error("Search.io event local storage key contains corrupt data.", storageContent);
    }

    this.flush().then(function () {
      return _this.purge();
    });
  }

  var _proto = SearchIOAnalytics.prototype;

  _proto.add = function add(queryId, type, value, metadata) {
    var eventsForValue = this.getEvents(value);
    eventsForValue.push({
      queryId: queryId,
      type: type,
      metadata: metadata,
      timestamp: Date.now(),
      submitted: false
    });
    this.setEvents(value, eventsForValue);
    this.save();
    this.flush();
  };

  _proto.save = function save() {
    setItem(STORAGE_KEY, JSON.stringify(this.events));
  };

  _proto.getIdentifierForType = function getIdentifierForType(type) {
    switch (type) {
      case "redirect":
        return "redirect_id";

      case "promotion_click":
        return "banner_id";

      default:
        return "result_id";
    }
  };

  _proto.flush = function flush() {
    var _this2 = this;

    var sends = [];
    Object.keys(this.events).forEach(function (value) {
      _this2.events[value].forEach(function (_ref, i) {
        var queryId = _ref.queryId,
            type = _ref.type,
            metadata = _ref.metadata,
            submitted = _ref.submitted;

        if (!submitted) {
          var _extends2;

          sends.push(_this2.sendEvent(queryId, type, _extends((_extends2 = {}, _extends2[_this2.getIdentifierForType(type)] = value, _extends2), metadata && {
            metadata: metadata
          })).then(function () {
            _this2.events[value][i].submitted = true;

            _this2.save();
          })["catch"](function () {
            console.error("Search.io event failed to send.", _this2.events[value][i]);
          }));
        }
      });
    });
    return Promise.all(sends)["catch"](function () {// We already log fails above
    });
  };

  _proto.sendEvent = /*#__PURE__*/function () {
    var _sendEvent = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(queryId, type, data) {
      var response, message, r;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(this.endpoint + "/v4/collections/" + this.collection + ":trackEvent", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "text/plain",
                  "Account-Id": this.account
                },
                body: JSON.stringify(_extends({
                  query_id: queryId,
                  type: type
                }, data))
              });

            case 2:
              response = _context.sent;

              if (response.ok) {
                _context.next = 17;
                break;
              }

              message = response.statusText;
              _context.prev = 5;
              _context.next = 8;
              return response.json();

            case 8:
              r = _context.sent;

              if (r.message) {
                message = r.message;
              }

              _context.next = 14;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);

            case 14:
              if (!(response.status === 403)) {
                _context.next = 16;
                break;
              }

              throw new RequestError(response.status, "This domain is not authorized to make this request.", new Error(message));

            case 16:
              throw new RequestError(response.status, "Request failed due to a configuration error.", new Error(message));

            case 17:
              return _context.abrupt("return", response.json());

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 12]]);
    }));

    function sendEvent(_x, _x2, _x3) {
      return _sendEvent.apply(this, arguments);
    }

    return sendEvent;
  }();

  _proto.getExpiry = function getExpiry() {
    return Date.now() - EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  };

  _proto.purge = function purge() {
    var _this3 = this;

    var expiry = this.getExpiry();
    var requiresSave = false;
    Object.keys(this.events).forEach(function (value) {
      var purged = _this3.events[value].filter(function (_ref2) {
        var submitted = _ref2.submitted,
            timestamp = _ref2.timestamp;
        return !submitted || timestamp > expiry;
      });

      if (purged.length < _this3.events[value].length) {
        _this3.setEvents(value, purged);

        requiresSave = true;
      }
    });
    requiresSave && this.save();
  };

  _proto.getEvents = function getEvents(value) {
    return (this.events[value] || []).slice();
  };

  _proto.setEvents = function setEvents(value, events) {
    if (events.length) {
      this.events[value] = events;
    } else {
      delete this.events[value];
    }
  }
  /**
   * Update the current queryId
   * @param queryId queryId that events calling track should be tracked against
   */
  ;

  _proto.updateQueryId = function updateQueryId(queryId) {
    this.queryId = queryId;
  }
  /**
   * Track events against the current queryId
   * @param type name of event to track (e.g. click, add_to_cart, purchase)
   * @param value unique result identifier (e.g. product sku)
   * @param metadata key/value pair of information relevant to the event
   */
  ;

  _proto.track = function track(type, value, metadata) {
    var queryId = this.queryId;

    if (FUNNEL_ENTRY_TYPES.includes(type)) {
      // Funnel entry events should always include their own queryId as they are tightly coupled to a specific query
      if (!queryId) {
        console.error("No queryId found. Use updateQueryId to set the current queryId or call trackForQuery with a specific queryId.");
        return;
      }
    } else {
      // Ad-hoc events always attempt a lookup of a previously saved queryId assocaited with this identifier
      var lastEvent = this.getEvents(value).pop();

      if (lastEvent) {
        queryId = lastEvent.queryId;
      }
    }

    if (!queryId) {
      return;
    }

    this.trackForQuery(queryId, type, value, metadata);
  }
  /**
   * Track events against a specific current queryId
   * @param queryId queryId that event should be tracked against
   * @param type name of event to track (e.g. click, add_to_cart, purchase)
   * @param value unique result identifier (e.g. product sku)
   * @param metadata key/value pair of information relevant to the event
   */
  ;

  _proto.trackForQuery = function trackForQuery(queryId, type, value, metadata) {
    this.add(queryId, type, value, metadata);
  };

  return SearchIOAnalytics;
}();

var _excluded = ["queryID"];
/**
 * NetworkError defines an error occuring from the network.
 */

var NetworkError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(NetworkError, _Error);

  function NetworkError(message) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.type = "CONNECTION";
    return _this;
  }

  return NetworkError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var configDefaults = {
  clickTokenURL: "https://re.sajari.com/token/",
  userAgent: ""
};
/**
 * Client defines a client for interacting with the Sajari API.
 */

var Client = /*#__PURE__*/function () {
  /**
   * Constructs an instance of Client for a specific account and collection.
   *
   * ```javascript
   * const client = new Client("<account_id>", "<collection_id>");
   * ```
   *
   * It is also possible to optionally set the API endpoint:
   *
   * ```javascript
   * const client = new Client("<account_id>", "<collection_id>", "<endpoint>");
   * ```
   *
   * @param project
   * @param collection
   * @param {string} [endpoint]
   */
  function Client(project, collection, endpoint, key, secret, config) {
    if (endpoint === void 0) {
      endpoint = (isSSR() ? "https:" : "") + "//jsonapi.sajari.net";
    }

    this.userAgent = ""; // Key/secret is only allowed in non SSR context

    if (!isSSR() && [key, secret].some(Boolean)) {
      throw new Error("key/secret authorization is only supported for server-side rendering.");
    }

    this.project = project;
    this.collection = collection;
    this.endpoint = endpoint;
    this.key = key;
    this.secret = secret;
    this.config = Object.assign(configDefaults, config);
    this.interactionConsume = this.interactionConsume.bind(this);
  }
  /**
   * call executes a request to the Sajari API
   */


  var _proto = Client.prototype;

  _proto.call =
  /*#__PURE__*/
  function () {
    var _call = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(path, request, signal) {
      var metadata, resp, code, message, _yield$resp$json;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!isSSR() && !navigator.onLine)) {
                _context.next = 2;
                break;
              }

              throw new NetworkError("Search request failed due to a network error. Please check your network connection.");

            case 2:
              metadata = {
                project: [this.project],
                collection: [this.collection],
                "user-agent": [[USER_AGENT, this.userAgent, this.config.userAgent].filter(Boolean).join(" ")]
              }; // Only allow key/secret for SSR contexts

              if (isSSR() && [this.key, this.secret].every(Boolean)) {
                Object.assign(metadata, {
                  authorization: ["keysecret " + this.key + " " + this.secret]
                });
              }

              _context.next = 6;
              return fetch("" + this.endpoint + path, {
                signal: signal,
                method: "POST",
                headers: {
                  Accept: "application/json",
                  // XXX: This is to remove the need for the OPTIONS request
                  // https://stackoverflow.com/questions/29954037/why-is-an-options-request-sent-and-can-i-disable-it
                  "Content-Type": "text/plain"
                },
                body: JSON.stringify({
                  metadata: metadata,
                  request: request
                })
              });

            case 6:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 24;
                break;
              }

              message = resp.statusText;
              _context.prev = 9;
              _context.next = 12;
              return resp.json();

            case 12:
              _yield$resp$json = _context.sent;
              code = _yield$resp$json.code;
              message = _yield$resp$json.message;
              _context.next = 19;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);

            case 19:
              if (!(resp.status === 403)) {
                _context.next = 22;
                break;
              }

              console.error("Check the domain " + window.location.hostname + " is an authorized query domain. See https://app.search.io/collection/domains");
              throw new RequestError(resp.status, "Search request failed due to a permission denied error.", new Error(message));

            case 22:
              console.error("Search request failed due to an error. HTTP code: " + resp.status + ", Code: " + code + ", Message: " + message);
              throw new RequestError(resp.status, "Search request failed due to an error.", new Error(message));

            case 24:
              _context.next = 26;
              return resp.json();

            case 26:
              return _context.abrupt("return", _context.sent);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[9, 17]]);
    }));

    function call(_x, _x2, _x3) {
      return _call.apply(this, arguments);
    }

    return call;
  }()
  /**
   * pipeline creates a new QueryPipeline instance that inherits configuration from the Client.
   * @param name pipeline name
   * @param {string} [version] pipeline version
   */
  ;

  _proto.pipeline = function pipeline(name, version) {
    return new QueryPipeline(this, name, version);
  }
  /**
   * On each result when using [[TrackingType.Click]] or [[TrackingType.PosNeg]], there is a set of tokens. These tokens allow you to provide feedback to the ranking system. When a user interacts with a result, you can send back the token with some extra information.
   *
   * The following example invocation of the consume function is noting that this particular interaction was a "purchase" and the user purchasing the item was 20 years old (this information comes from some system that you operate.)
   *
   * ```javascript
   * client.interactionConsume(token, "purchase", 1.0, {
   *   age: "20",
   * });
   * ```
   * @deprecated in favor of [[SearchIOAnalytics]] tracking APIs.
   */
  ;

  _proto.interactionConsume =
  /*#__PURE__*/
  function () {
    var _interactionConsume = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(token, identifier, weight, data) {
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (data === void 0) {
                data = {};
              }

              return _context2.abrupt("return", this.call("/sajari.interaction.v2.Interaction/ConsumeToken", {
                token: token,
                identifier: identifier,
                weight: weight,
                data: data
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function interactionConsume(_x4, _x5, _x6, _x7) {
      return _interactionConsume.apply(this, arguments);
    }

    return interactionConsume;
  }();

  return Client;
}();
/**
 * Type of pipeline.
 */

var PipelineType;

(function (PipelineType) {
  /**
   * Query pipeline.
   */
  PipelineType[PipelineType["Query"] = 1] = "Query";
  /**
   * Record pipeline.
   */

  PipelineType[PipelineType["Record"] = 2] = "Record";
})(PipelineType || (PipelineType = {}));

var EVENT_SEARCH_SENT = "search-sent";
/**
 * QueryPipeline is a client for running query pipelines on a collection.  See
 * [[QueryPipeline.search]] for more details.
 *
 * Create a new QueryPipeline via [[Client.pipeline]].
 *
 * ```javascript
 * // const client = new Client(...);
 * const pipeline = client.pipeline("website");
 * ```
 */

var QueryPipeline = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(QueryPipeline, _EventEmitter);

  function QueryPipeline(client, name, version) {
    var _this2;

    _this2 = _EventEmitter.call(this) || this;
    _this2.client = client;
    _this2.identifier = {
      name: name,
      version: version
    };
    return _this2;
  }
  /**
   * Search runs a search query defined by a pipeline with the given values and
   * session configuration.
   *
   * ```javascript
   * pipeline.search({ q: "<search query>" })
   *  .then(([response, values]) => {
   *    // handle response
   *  })
   *  .catch(error => {
   *    // handle error
   * })
   * ```
   *
   * @param values
   * @param tracking
   */


  var _proto2 = QueryPipeline.prototype;

  _proto2.search =
  /*#__PURE__*/
  function () {
    var _search = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(values, tracking) {
      var _this3 = this;

      var pt, queryID, rest, jsonProto, searchResponse, redirects, tokens, activePromotions, banners, queryId, activePins, results;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              pt = {
                type: TrackingType.None
              };

              if (tracking !== undefined) {
                queryID = tracking.queryID, rest = _objectWithoutPropertiesLoose(tracking, _excluded);
                pt = _extends({
                  query_id: queryID
                }, rest);
              }

              this.emit(EVENT_SEARCH_SENT, values);
              _context3.next = 5;
              return this.client.call("/sajari.api.pipeline.v1.Query/Search", {
                pipeline: this.identifier,
                tracking: pt,
                values: values
              });

            case 5:
              jsonProto = _context3.sent;
              searchResponse = jsonProto.searchResponse, redirects = jsonProto.redirects, tokens = jsonProto.tokens, activePromotions = jsonProto.activePromotions, banners = jsonProto.banners, queryId = jsonProto.queryId;
              activePins = formatActivePins(activePromotions);
              results = ((searchResponse == null ? void 0 : searchResponse.results) || []).map(function (_ref, index) {
                var indexScore = _ref.indexScore,
                    score = _ref.score,
                    values = _ref.values,
                    neuralScore = _ref.neuralScore,
                    featureScore = _ref.featureScore;
                var t = undefined;
                var token = (tokens || [])[index];

                if (token !== undefined) {
                  if ("click" in token) {
                    t = {
                      click: _this3.client.config.clickTokenURL + token.click.token
                    };
                  } else if ("pos" in token) {
                    t = _extends({}, token);
                  } else if ("posNeg" in token) {
                    t = {
                      pos: token.posNeg.pos,
                      neg: token.posNeg.neg
                    };
                  }
                }

                var promotionPinned = false;

                if (Object.keys(activePins).length > 0) {
                  Object.entries(activePins).forEach(function (_ref2) {
                    var pinKeyFieldName = _ref2[0],
                        pinKeyFieldValues = _ref2[1];

                    if (!(pinKeyFieldName in values)) {
                      console.error("Pin key field \"" + pinKeyFieldName + "\" not found in values.", values);
                      return;
                    }

                    var fieldValue = valueFromProto(values[pinKeyFieldName]);

                    if (typeof fieldValue === "string" && pinKeyFieldValues.has(fieldValue)) {
                      promotionPinned = true;
                    }
                  });
                }

                return _extends({
                  indexScore: indexScore
                }, neuralScore && {
                  neuralScore: neuralScore
                }, featureScore && {
                  featureScore: featureScore
                }, {
                  score: score,
                  values: processProtoValues(values),
                  token: t,
                  promotionPinned: promotionPinned
                });
              });
              return _context3.abrupt("return", [_extends({
                time: parseFloat((searchResponse == null ? void 0 : searchResponse.time) || "0.0"),
                totalResults: parseInt((searchResponse == null ? void 0 : searchResponse.totalResults) || "0", 10),
                banners: banners,
                featureScoreWeight: (searchResponse == null ? void 0 : searchResponse.featureScoreWeight) || 0,
                results: results,
                aggregates: formatAggregates(searchResponse == null ? void 0 : searchResponse.aggregates),
                aggregateFilters: formatAggregates(searchResponse == null ? void 0 : searchResponse.aggregateFilters),
                redirects: prependClickTokenUrl(this.client.config.clickTokenURL, redirects),
                activePromotions: activePromotions != null ? activePromotions : []
              }, queryId && {
                queryId: queryId
              }), jsonProto.values || {}]);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function search(_x8, _x9) {
      return _search.apply(this, arguments);
    }

    return search;
  }();

  return QueryPipeline;
}(EventEmitter);

function formatActivePins(activePromotions) {
  if (activePromotions === void 0) {
    activePromotions = [];
  }

  var pins = {};
  activePromotions.forEach(function (_ref3) {
    var activePins = _ref3.activePins;
    activePins == null ? void 0 : activePins.forEach(function (_ref4) {
      var key = _ref4.key;

      if (!pins[key.field]) {
        pins[key.field] = new Set();
      }

      pins[key.field].add(key.value);
    });
  });
  return pins;
}

function prependClickTokenUrl(clickTokenURL, redirects) {
  if (redirects === void 0) {
    redirects = {};
  }

  return Object.entries(redirects).reduce(function (acc, _ref5) {
    var queryString = _ref5[0],
        target = _ref5[1];
    acc[queryString] = target;
    acc[queryString]["token"] = clickTokenURL + acc[queryString]["token"];
    return acc;
  }, {});
}

function formatAggregates(aggregatesProto) {
  if (aggregatesProto === void 0) {
    aggregatesProto = {};
  }

  return Object.entries(aggregatesProto).map(function (_ref6) {
    var key = _ref6[0],
        aggregate = _ref6[1];

    if ("metric" in aggregate) {
      var _key$split = key.split("."),
          t = _key$split[0],
          k = _key$split[1];

      return {
        type: t,
        key: k,
        value: aggregate.metric.value
      };
    }

    if ("count" in aggregate) {
      return {
        type: "count",
        key: key.replace(/^count./, ""),
        value: aggregate.count.counts
      };
    }

    if ("buckets" in aggregate) {
      var _aggregate$buckets$bu, _aggregate$buckets;

      return {
        type: "count",
        key: "buckets",
        value: Object.values((_aggregate$buckets$bu = (_aggregate$buckets = aggregate.buckets) == null ? void 0 : _aggregate$buckets.buckets) != null ? _aggregate$buckets$bu : {}).reduce(function (obj, _ref7) {
          var _Object$assign;

          var name = _ref7.name,
              count = _ref7.count;
          return Object.assign(obj, (_Object$assign = {}, _Object$assign[name] = count, _Object$assign));
        }, {})
      };
    }

    return {
      key: key,
      value: aggregate
    };
  }).reduce(function (obj, item) {
    if (item.type === undefined) {
      console.debug(item);
      return obj;
    }

    if (obj[item.key] === undefined) {
      obj[item.key] = {};
    }

    var field = obj[item.key][item.type];

    if (item.type === "count" && item.key === "buckets" && typeof field === "object" && typeof item.value === "object") {
      field = _extends({}, field, item.value);
      obj[item.key][item.type] = field;
    } else {
      // @ts-ignore
      obj[item.key][item.type] = item.value;
    }

    return obj;
  }, {});
}
/**
 * TextPosition describes the position of text in a box.
 *
 *  - TEXT_POSITION_UNSPECIFIED: No position specified.
 *  - TEXT_POSITION_CENTER: The text is positioned in the horizontal and vertical center.
 *  - TEXT_POSITION_TOP_LEFT: The text is positioned in the top left corner.
 *  - TEXT_POSITION_TOP_RIGHT: The text is positioned in the top right corner.
 *  - TEXT_POSITION_BOTTOM_LEFT: The text is positioned in the bottom left corner.
 *  - TEXT_POSITION_BOTTOM_RIGHT: The text is positioned in the bottom right corner.
 * @export
 * @enum {string}
 */

var TextPosition;

(function (TextPosition) {
  TextPosition["Unspecified"] = "TEXT_POSITION_UNSPECIFIED";
  TextPosition["Center"] = "TEXT_POSITION_CENTER";
  TextPosition["TopLeft"] = "TEXT_POSITION_TOP_LEFT";
  TextPosition["TopRight"] = "TEXT_POSITION_TOP_RIGHT";
  TextPosition["BottomLeft"] = "TEXT_POSITION_BOTTOM_LEFT";
  TextPosition["BottomRight"] = "TEXT_POSITION_BOTTOM_RIGHT";
})(TextPosition || (TextPosition = {}));
/**
 * @hidden
 */


function processProtoValues(values) {
  var vs = {};
  Object.keys(values).forEach(function (key) {
    var v = valueFromProto(values[key]);

    if (v !== null) {
      vs[key] = v;
    }
  });
  return vs;
}
/**
 * @hidden
 */


function valueFromProto(value) {
  if ("single" in value) {
    return value.single;
  } else if ("repeated" in value) {
    return value.repeated.values;
  } else if ("singleBytes" in value) {
    return value.singleBytes;
  }

  return null;
}
/**
 * TrackingType defines the possible result-interaction tracking types used by [[Session]]
 */


var TrackingType;

(function (TrackingType) {
  /**
   * None disables tracking.
   */
  TrackingType["None"] = "NONE";
  /**
   * Click generates click tracking tokens.
   * @deprecated Use EVENT for new tracking APIs
   */

  TrackingType["Click"] = "CLICK";
  /**
   * PosNeg creates pos/neg tracking tokens.
   * @deprecated Use EVENT for new tracking APIs
   */

  TrackingType["PosNeg"] = "POS_NEG";
  /**
   * Event uses simplified tracking.
   */

  TrackingType["Event"] = "EVENT";
})(TrackingType || (TrackingType = {}));

var EVENT_TRACKING_RESET = "tracking-reset";
/**
 * DefaultSession holds state of a sequence of searches.
 * @deprecated Use [[SearchIOAnalytics]] which does not attempt to track search sequences in the client.
 */

var DefaultSession = /*#__PURE__*/function (_EventEmitter2) {
  _inheritsLoose(DefaultSession, _EventEmitter2);

  function DefaultSession(type, field, data) {
    var _this4;

    _this4 = _EventEmitter2.call(this) || this;
    _this4.queryID = "";
    _this4.sequence = 0;
    _this4.type = type;
    _this4.field = field;
    _this4.data = mergeTrackingData(data);
    return _this4;
  }

  var _proto3 = DefaultSession.prototype;

  _proto3.next = function next(_) {
    if (this.queryID === "") {
      this.queryID = newQueryID();
      this.sequence = 0;
    } else {
      this.sequence++;
    }

    return {
      type: this.type,
      queryID: this.queryID,
      sequence: this.sequence,
      field: this.field,
      data: this.data
    };
  };

  _proto3.reset = function reset() {
    this.emit(EVENT_TRACKING_RESET);
    this.queryID = "";
    this.sequence = 0;
  };

  return DefaultSession;
}(EventEmitter);
/**
 * mergeTrackingData combines the provided session data with the requesters
 * google analytics ID and/or Sajari ID if present in the documents cookie.
 *
 * Because this is meant to be used on the client side, when in SSR mode
 * it will always return empty object
 * @hidden
 */

function mergeTrackingData(data) {
  if (typeof window === "undefined") {
    return {};
  }

  var cookieData = document.cookie.split(";").filter(function (item) {
    return item.includes("_ga") || item.includes("sjID");
  }).map(function (item) {
    return item.split("=");
  }).reduce(function (data, _ref8) {
    var key = _ref8[0],
        val = _ref8[1];

    if (key === "_ga") {
      data["ga"] = val;
      return data;
    }

    data[key] = val;
    return data;
  }, {});

  if (data === undefined) {
    return cookieData;
  }

  Object.entries(cookieData).forEach(function (_ref9) {
    var key = _ref9[0],
        val = _ref9[1];
    data[key] = val;
  });
  return data;
}
/**
 * newQueryID constructs a new ID for a query.
 * @hidden
 */


function newQueryID(len) {
  if (len === void 0) {
    len = 16;
  }

  var output = "";

  for (var i = 0; i < len; i++) {
    output += "abcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(Math.random() * 36));
  }

  return output;
}
/**
 * InteractiveSession creates a session based on text searches and is recommended
 * for use in search-as-you-type style interfaces.
 *
 * It resets the session if the search query value:
 *
 * - Is `undefined`.
 * - First 3 characters have changed (i.e. from a direct replacement)
 * - Cleared after being non-empty (i.e. from a delete)
 * @deprecated  The new API, [[SearchIOAnalytics]], does not track search 'sessions' in the client.
 */


var InteractiveSession = /*#__PURE__*/function () {
  function InteractiveSession(textParam, session) {
    this.textParam = textParam;
    this.session = session;
    this.lastQuery = "";
  }

  var _proto4 = InteractiveSession.prototype;

  _proto4.next = function next(values) {
    var text = values[this.textParam];

    if (text === undefined) {
      this.reset();
      return this.session.next(values);
    }

    var shortendPreviousQuery = this.lastQuery.substr(0, Math.min(text.length, 3));
    var firstThreeCharsChanged = text.substr(0, shortendPreviousQuery.length) !== shortendPreviousQuery;
    var queryCleared = this.lastQuery.length > 0 && text.length === 0;

    if (firstThreeCharsChanged || queryCleared) {
      this.reset();
    }

    this.lastQuery = text;
    return this.session.next(values);
  };

  _proto4.reset = function reset() {
    this.session.reset();
  };

  return InteractiveSession;
}();
var EVENT_SELECTION_UPDATED = "selection-updated";
var EVENT_OPTIONS_UPDATED = "options-updated";
var Filter = /*#__PURE__*/function (_EventEmitter3) {
  _inheritsLoose(Filter, _EventEmitter3);

  function Filter(options, initial, multi, joinOp) {
    var _this5;

    if (initial === void 0) {
      initial = [];
    }

    if (multi === void 0) {
      multi = false;
    }

    if (joinOp === void 0) {
      joinOp = "OR";
    }

    _this5 = _EventEmitter3.call(this) || this;
    _this5.options = options;
    _this5.active = initial;
    _this5.multi = multi;
    _this5.joinOp = joinOp;
    return _this5;
  }

  var _proto5 = Filter.prototype;

  _proto5.set = function set(key, active) {
    if (active === void 0) {
      active = true;
    }

    if (this.multi) {
      if (active && this.active.indexOf(key) === -1) {
        this.active = this.active.concat(key);
      } else {
        this.active = this.active.filter(function (k) {
          return k !== key;
        });
      }

      this.emit(EVENT_SELECTION_UPDATED, [].concat(this.active));
      return;
    }

    if (active) {
      this.active = [key];
    } else {
      this.active = [];
    }

    this.emit(EVENT_SELECTION_UPDATED, [].concat(this.active));
  };

  _proto5.isActive = function isActive(key) {
    return this.active.indexOf(key) !== -1;
  };

  _proto5.get = function get() {
    return [].concat(this.active);
  };

  _proto5.updateOptions = function updateOptions(options) {
    var _this6 = this;

    Object.keys(options).forEach(function (key) {
      var value = options[key];

      if (value === undefined) {
        delete _this6.options[key];
        _this6.active = _this6.active.filter(function (k) {
          return k !== key;
        });
        return;
      }

      _this6.options[key] = value;
    });
    this.emit(EVENT_OPTIONS_UPDATED, _extends({}, this.options));
  };

  _proto5.getOptions = function getOptions() {
    return _extends({}, this.options);
  };

  _proto5.filter = function filter() {
    var _this7 = this;

    var filters = this.active.map(function (key) {
      var filter = _this7.options[key];

      if (typeof filter === "function") {
        filter = filter();
      }

      if (filter !== "") {
        filter = "(" + filter + ")";
      }

      return filter;
    }).filter(Boolean);

    switch (filters.length) {
      case 0:
        return "";

      case 1:
        return filters[0];

      default:
        return filters.join(" " + this.joinOp + " ");
    }
  };

  return Filter;
}(EventEmitter);
var EVENT_VALUES_UPDATED = "values-changed";
var Values = /*#__PURE__*/function (_EventEmitter4) {
  _inheritsLoose(Values, _EventEmitter4);

  function Values(initial) {
    var _this8;

    if (initial === void 0) {
      initial = {};
    }

    _this8 = _EventEmitter4.call(this) || this;
    _this8.internal = initial;
    return _this8;
  }

  var _proto6 = Values.prototype;

  _proto6._internalUpdate = function _internalUpdate(values) {
    var _this9 = this;

    Object.keys(values).forEach(function (key) {
      var value = values[key];

      if (value === undefined) {
        delete _this9.internal[key];
      } else {
        _this9.internal[key] = value;
      }
    });
  };

  _proto6.update = function update(values) {
    var _this10 = this;

    this._internalUpdate(values);

    this.emit(EVENT_VALUES_UPDATED, values, function (values) {
      return _this10._internalUpdate(values);
    });
  };

  _proto6.get = function get() {
    var values = {};
    Object.entries(this.internal).forEach(function (_ref10) {
      var key = _ref10[0],
          value = _ref10[1];

      if (typeof value === "function") {
        values[key] = value();
      } else if (Array.isArray(value)) {
        values[key] = value.join(",");
      } else {
        values[key] = "" + value;
      }
    });
    return values;
  };

  return Values;
}(EventEmitter);
var POS_NEG_STORAGE_KEY = "sajari_tokens";
/**
 * PosNegLocalStorageManager is a utility class for manipulating Sajari's localstorage based
 * management of PosNeg tokens. Typical use case is storing tokens for later consumption
 * as users move through an ecommerce purchase funnel.
 * @deprecated See [[SearchIOAnalytics]] for new tracking APIs.
 */

var PosNegLocalStorageManager = /*#__PURE__*/function () {
  function PosNegLocalStorageManager(client) {
    var storageContent = getItem(POS_NEG_STORAGE_KEY);

    try {
      this.currentTokens = storageContent ? JSON.parse(storageContent) : {};
    } catch (e) {
      this.currentTokens = {};
      console.error("Sajari PosNeg local storage key contains corrupt data.", storageContent);
    }

    this.client = client;
  }

  var _proto7 = PosNegLocalStorageManager.prototype;

  _proto7.add = function add(fieldValue, token) {
    this.currentTokens[fieldValue] = {
      token: token,
      clickSubmitted: false
    };
    setItem(POS_NEG_STORAGE_KEY, JSON.stringify(this.currentTokens));
  };

  _proto7.get = function get(fieldValue) {
    return this.currentTokens[fieldValue];
  };

  _proto7.sendPosEvent = function sendPosEvent(fieldValue, identifier, weight) {
    var tokenState = this.get(fieldValue);

    if (tokenState === undefined) {
      return;
    }

    this.client.interactionConsume(tokenState.token.pos, identifier, weight);
  };

  _proto7.sendClickEvent = function sendClickEvent(fieldValue) {
    var tokenState = this.get(fieldValue);

    if (tokenState === undefined || tokenState.clickSubmitted !== false) {
      return;
    }

    this.sendPosEvent(fieldValue, "click", 1);
    this.currentTokens[fieldValue].clickSubmitted = true;
    setItem(POS_NEG_STORAGE_KEY, JSON.stringify(this.currentTokens));
  };

  _proto7.sendPendingClicks = function sendPendingClicks() {
    var _this11 = this;

    Object.keys(this.currentTokens).forEach(function (fieldValue) {
      if (_this11.currentTokens[fieldValue].clickSubmitted === false) {
        _this11.sendClickEvent(fieldValue);

        _this11.currentTokens[fieldValue].clickSubmitted = true;
      }
    });
  };

  return PosNegLocalStorageManager;
}();

export { Client, DefaultSession, EVENT_OPTIONS_UPDATED, EVENT_SEARCH_SENT, EVENT_SELECTION_UPDATED, EVENT_TRACKING_RESET, EVENT_VALUES_UPDATED, EventEmitter, Filter, InteractiveSession, NetworkError, POS_NEG_STORAGE_KEY, PipelineType, PosNegLocalStorageManager, RequestError, SearchIOAnalytics, TextPosition, TrackingType, Values, formatAggregates, getItem, setItem };
//# sourceMappingURL=sajarisdk.esm.js.map
